import { Getters } from "vuex-smart-module";
import FeaturesState from "./state";
import coordsFormater from "@/utils/coords_formater";
import { IMobilePlatformsProperties } from "./models";

export default class FeaturesGetters extends Getters<FeaturesState> {
  //Getters directos
  get mobilePlatforms() {
    return this.state.mobilePlatforms;
  }
  get fixedPlatforms() {
    return this.state.fixedPlatforms;
  }
  get linealPlatforms() {
    return this.state.linealPlatforms;
  }
  get platformTagEnabled() {
    return this.state.platformTag;
  }
  get chartAchare() {
    return this.state.chartAchare;
  }
  get selectedFixedPlatform() {
    return this.state.selectedFixedPlatform;
  }
  get selectedMobilePlatform() {
    return this.state.selectedMobilePlatform;
  }
  get navChannels() {
    return this.state.channels;
  }
  get pipeLines() {
    return this.state.pipelines;
  }
  //Getters para las tablas
  get getMobilePlatformsinfo():IMobilePlatformsProperties[] {
    return this.state.mobilePlatforms.map((rig) => {
      return {
        id: rig.id,
        nombre: rig.properties.nombre,
        modified: new Date(rig.properties.modified).toLocaleDateString("es-mx"),
        created_by: rig.properties.created_by,
        created: rig.properties.created,
        descripcion: rig.properties.descripcion,
        tipo: rig.properties.tipo,
        coordenadas: coordsFormater(rig.geometry.coordinates),
      };
    });
  }
  get getFixedPlatformsinfo() {
    return this.state.fixedPlatforms.map((rig) => {
      return {
        id: rig.id,
        name: rig.properties.nombre,
      };
    });
  }
  //Getters para búsquedas
  searchFixedPlatformById(id: number) {
    return this.state.fixedPlatforms.find((platform) => platform.id === id);
  }
  searchMobilePlatformById(id: number) {
    return this.state.mobilePlatforms.find((platform) => platform.id === id);
  }
}
